module.exports = __webpack_public_path__ + "static/media/NoRoomPhoto@2x.925244b0.png";